export default "__VITE_ASSET__3e671476__"